import { SideContext } from '@/App';
import { SideStatus } from '@/commons/context/side-store';
import { graphicStore } from '@/commons/store/graphic-store';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import { useContext, useState } from 'react';

import { ReactComponent as ZhouwangSvg } from '@/commons/icons/new/zhouwang.svg';
import { ReactComponent as QiangSvg } from '@/commons/icons/new/qiang.svg';
import { ReactComponent as LoubanSvg } from '@/commons/icons/new/louban.svg';
import { ReactComponent as DiaodingSvg } from '@/commons/icons/new/diaoding.svg';
import { ReactComponent as ZhuSvg } from '@/commons/icons/new/zhu.svg';
import { ReactComponent as MenSvg } from '@/commons/icons/new/men.svg';
import { ReactComponent as ChuangSvg } from '@/commons/icons/new/chuang.svg';
import { ReactComponent as DongkouSvg } from '@/commons/icons/new/dongkou.svg';
import { ReactComponent as JiaoxiangSvg } from '@/commons/icons/new/jiaoxiang.svg';
import { ReactComponent as LoutiSvg } from '@/commons/icons/new/louti.svg';
import { ReactComponent as StationSvg } from '@/commons/icons/new/station.svg';
import { ReactComponent as RoofSlabSvg } from '@/commons/icons/new/roof-slab.svg';
import { ReactComponent as EavesBoardSvg } from '@/commons/icons/new/eaves-board.svg';
import { ReactComponent as GutterSvg } from '@/commons/icons/new/gutter.svg';

import { ReactComponent as LoucengSvg } from '@/commons/icons/new/louceng.svg';
import { ReactComponent as FangjianSvg } from '@/commons/icons/new/fangjian.svg';
import { ReactComponent as DiantiSvg } from '@/commons/icons/new/dianti.svg';
import { ReactComponent as XiaokongshiSvg } from '@/commons/icons/new/xiaokongshi.svg';
import { ReactComponent as BengfangSvg } from '@/commons/icons/new/bengfang.svg';

import { ReactComponent as CaizhiSvg } from '@/commons/icons/new/caizhi.svg';

import { ReactComponent as BiaogaoSvg } from '@/commons/icons/menu/building/biaogao.svg';
import { ReactComponent as BolimianbanSvg } from '@/commons/icons/menu/building/bolimianban.svg';
import { ReactComponent as CaiguangSvg } from '@/commons/icons/menu/building/caiguang.svg';
import { ReactComponent as GeqiangSvg } from '@/commons/icons/menu/building/geqiang.svg';
import { ReactComponent as LoubandongkouSvg } from '@/commons/icons/menu/building/loubandongkou.svg';
import { ReactComponent as LoutaiSvg } from '@/commons/icons/menu/building/loutai.svg';
import { ReactComponent as LanganSvg } from '@/commons/icons/menu/building/langan.svg';
import { ReactComponent as MuqiangSvg } from '@/commons/icons/menu/building/muqiang.svg';
import { ReactComponent as PodaoSvg } from '@/commons/icons/menu/building/podao.svg';
import { ReactComponent as QiangmiandongkouSvg } from '@/commons/icons/menu/building/qiangmiandongkou.svg';

import { ReactComponent as QuyudingyiSvg } from '@/commons/icons/menu/building/quyudingyi.svg';
import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as ZhichengjiegouSvg } from '@/commons/icons/menu/building/zhichengjiegou.svg';
import { ReactComponent as YangtaiSvg } from '@/commons/icons/menu/building/yangtai.svg';
import { ReactComponent as WudingSvg } from '@/commons/icons/menu/building/wuding.svg';
import { ReactComponent as TongdaoSvg } from '@/commons/icons/menu/building/tongdao.svg';
import { ReactComponent as TaijieSvg } from '@/commons/icons/menu/building/taijie.svg';
import { ReactComponent as ShimianSvg } from '@/commons/icons/menu/building/shimian.svg';
import { ReactComponent as RizhaofenxiSvg } from '@/commons/icons/menu/building/rizhaofenxi.svg';

import { ReactComponent as MianjiSvg } from '@/commons/icons/menu/building/mianji.svg';
import { ReactComponent as FenggeSvg } from '@/commons/icons/new/fengge.svg'
import { ReactComponent as YingyingSvg } from '@/commons/icons/new/yingying.svg';
import { ARCHI_SUB_CONTROL } from '@/passets/archibase-engine/enums/archi-sub-control';
import { getSpecialPrimitiveLayerUuid } from '@/commons/utils/layer-utils';
import { useParams } from 'react-router-dom';
import { LayerType } from '@/commons/enums/layer-type';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal';
import { TnEngineExtraContext } from 'pytha';
import { getRenderDataJson } from '@/commons/utils/model-utils';
import { exportRenderData, newDownloadBackup } from '@/api/geometry/primitive';
import { Tooltip, message } from 'antd';
import { OrthographicCamera } from 'three';
import DownloadProjectModal from './download-project/DownloadProjectModal';

export default function BuildingMenu() {
    const { projectUuid, modelUuid } = useParams();
    const sideContext = useContext<SideStatus>(SideContext);

    const [loading, setLoading] = useState<boolean>(false)
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const onClick = (route: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
    }

    const onActiveSubControl = (cmd: string) => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
    }

    const onClickRenderData = () => {
        setLoading(true)
        let data = getRenderDataJson()
        exportRenderData(projectUuid, modelUuid, data).then(res => {
            message.success("导出结束")
        }).catch(e => {
            message.error("导出模型量过多，导出失败！")
        }).finally(() => {
            setLoading(false)
        })
    }

    const onClickDownloadProject = () => {
        setIsModalVisible(true); // 打开弹窗
    };

    const closeModal = () => {
        setIsModalVisible(false); // 关闭弹窗
    };



    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><BiaogaoSvg /></div>
                                <div className='name'>标高</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.storey) }}>
                                <div className='icon'><LoucengSvg /></div>
                                <div className='name'>楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.axis_net) }}>
                                <div className='icon'><ZhouwangSvg /></div>
                                <div className='name'>轴网</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.floor) }}>
                                <div className='icon'><LoubanSvg /></div>
                                <div className='name'>楼地面</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><WudingSvg /></div>
                                <div className='name'>屋顶</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.roof_slab) }}>
                                <div className='icon'><RoofSlabSvg /></div>
                                <div className='name'>屋面板</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.eaves_board) }}>
                                <div className='icon'><EavesBoardSvg /></div>
                                <div className='name'>檐口板</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.gutter) }}>
                                <div className='icon'><GutterSvg /></div>
                                <div className='name'>天沟</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.ceiling) }}>
                                <div className='icon'><DiaodingSvg /></div>
                                <div className='name'>吊顶</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.wall) }}>
                                <div className='icon'><QiangSvg /></div>
                                <div className='name'>承重墙</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><GeqiangSvg /></div>
                                <div className='name'>隔墙</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><MuqiangSvg /></div>
                                <div className='name'>幕墙</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhichengjiegouSvg /></div>
                                <div className='name'>支架结构</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><BolimianbanSvg /></div>
                                <div className='name'>玻璃面板</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.column) }}>
                                <div className='icon'><ZhuSvg /></div>
                                <div className='name'>柱</div>
                            </div>
                        </div>


                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.door) }}>
                                <div className='icon'><MenSvg /></div>
                                <div className='name'>门</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.window) }}>
                                <div className='icon'><ChuangSvg /></div>
                                <div className='name'>窗</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TaijieSvg /></div>
                                <div className='name'>台阶</div>
                            </div>
                        </div>

                        <div className='ope-col'>
                            <div className='ope-item name2 ' onClick={() => { onActiveSubControl('WEDGE') }}>
                                <div className='icon'><PodaoSvg /></div>
                                <div className='name'>坡道</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><LoutiSvg /></div>
                                <div className='name'>楼梯</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><LanganSvg /></div>
                                <div className='name'>栏杆</div>
                            </div>
                        </div>

                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.elevator) }}>
                                <div className='icon'><DiantiSvg /></div>
                                <div className='name'>电梯</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><LoubandongkouSvg /></div>
                                <div className='name'>楼板洞口</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><QiangmiandongkouSvg /></div>
                                <div className='name'>墙面洞口</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShimianSvg /></div>
                                <div className='name'>饰面</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.room) }}>
                                <div className='icon'><FangjianSvg /></div>
                                <div className='name'>房间</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TongdaoSvg /></div>
                                <div className='name'>通道</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><LoutaiSvg /></div>
                                <div className='name'>楼台</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YangtaiSvg /></div>
                                <div className='name'>阳台</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><QuyudingyiSvg /></div>
                                <div className='name'>区域定义</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><MianjiSvg /></div>
                                <div className='name'>面积</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><CaiguangSvg /></div>
                                <div className='name'>采光</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><RizhaofenxiSvg /></div>
                                <div className='name'>日照分析</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.hole) }}>
                                <div className='icon'><DongkouSvg /></div>
                                <div className='name'>洞口</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.elevator_car) }}>
                                <div className='icon'><JiaoxiangSvg /></div>
                                <div className='name'>轿厢</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.texture) }}>
                                <div className='icon'><CaizhiSvg /></div>
                                <div className='name'>材质</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.station) }}>
                                <div className='icon'><StationSvg /></div>
                                <div className='name'>站台</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.fire_control_room) }}>
                                <div className='icon'><XiaokongshiSvg /></div>
                                <div className='name'>消控室</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.pump_room) }}>
                                <div className='icon'><BengfangSvg /></div>
                                <div className='name'>泵房</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.escape_route) }}>
                                <div className='icon'><BengfangSvg /></div>
                                <div className='name'>消防通道</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.elevator_group) }}>
                                <div className='icon'><DiantiSvg /></div>
                                <div className='name'>全楼电梯</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item' style={{ width: 61 }} onClick={() => onClick(SIDE_TYPE.roam_route)}>
                                <div className='icon'><FenggeSvg /></div>
                                <div className='name'>路线</div>
                            </div>
                            <Tooltip title="小程序渲染数据" arrow={false} >
                                <div className='ope-item' style={{ width: 61 }} onClick={() => {
                                    onClick(SIDE_TYPE.render_data)
                                }}>
                                    <div className='icon'><CaizhiSvg /></div>
                                    <div className='name'>导出</div>
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <Tooltip title="项目数据转移下载" arrow={false} >
                                <div className='ope-item' style={{ width: 61 }} onClick={() => onClickDownloadProject()}>
                                    <div className='icon'><FenggeSvg /></div>
                                    <div className='name'>下载</div>
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <DownloadProjectModal
                visible={isModalVisible}
                onClose={closeModal}
                projectUuid={projectUuid || ''}
                newDownloadBackup={newDownloadBackup} // 使用你的真实下载方法
            />
        </div >
    )
}
